<div class="nc4-wizard">
    @for (step of stepTitles; track step; let i = $index; let last = $last) {
        <div
            class="step"
            [ngClass]="{
            'step-active': i === activeStep,
            'step-visited': i < activeStep,
            'step-disabled': i > activeStep || disabled
        }"
        >
            <div class="step-container" [ngClass]="delayAnimation(i)" (click)="changeStep(i)">
                <h3 class="step-text" [translate]="step"></h3>
            </div>
            @if (!last) {
                <div
                    class="step-separator"
                    [ngClass]="{ 'step-separator-active': i + 1 === activeStep }"
                    [@step]="{
                        value: i + 1 === activeStep ? 'active' : i + 1 < activeStep ? 'visited' : 'disabled',
                        params: {
                            delay: 150 * (previousStep - (i + 1)) - (i + 1 === activeStep ? 150 : 0)
                        }
                    }"
                ></div>
            }
        </div>
    }
</div>
